module.exports = __webpack_public_path__ + "img/avoiding.f2ce32bf.png";